import type { FaireProductEntity } from "../../entity_types/product";

export const ai_bulk_9: FaireProductEntity = {
  token: "ai_bulk_9",
  type: "product",
  name: "Yellow/Green",
  brandName: "Ai Bulk Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/76b4266c7cda2f4e5ee69e4b9e88a252b6834f56d1fdf25379a36d400f1bcb4e.jpeg?bg-color=FFFFFF&canvas=720:720&dpr=1&fit=bounds&format=jpg&height=720&width=720",
  priceDollars: 22.0,
  msrpDollars: 44.0,
  description: "",
  tags: ["women-owned"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
